var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("home.batchReview"),
            visible: _vm.batchReviewDialog,
            width: "580px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchReviewDialog = $event
            },
          },
        },
        [
          _c("div", [
            _c(
              "div",
              { staticStyle: { "font-size": "16px", "font-weight": "bold" } },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("GlobalSetObj.totalOptions")) +
                    ": " +
                    _vm._s(_vm.selectDataList.length) +
                    " "
                ),
              ]
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "medium" },
                    on: { change: _vm.changeAuditsState },
                    model: {
                      value: _vm.auditsState,
                      callback: function ($$v) {
                        _vm.auditsState = $$v
                      },
                      expression: "auditsState",
                    },
                  },
                  [
                    _c("el-radio-button", { attrs: { label: 1 } }, [
                      _vm._v(_vm._s(_vm.$t("receivablePayable.Approved"))),
                    ]),
                    _c("el-radio-button", { attrs: { label: 0 } }, [
                      _vm._v(_vm._s(_vm.$t("orderCenterCont.ReviewFailed"))),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.auditsState === 0
              ? _c(
                  "div",
                  { staticStyle: { "margin-top": "20px" } },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        attrs: { size: "medium" },
                        model: {
                          value: _vm.singeOrPhoto,
                          callback: function ($$v) {
                            _vm.singeOrPhoto = $$v
                          },
                          expression: "singeOrPhoto",
                        },
                      },
                      [
                        _c("el-checkbox-button", { attrs: { label: 1 } }, [
                          _vm._v(_vm._s(_vm.$t("home.photoStandard"))),
                        ]),
                        _c("el-checkbox-button", { attrs: { label: 2 } }, [
                          _vm._v(_vm._s(_vm.$t("home.signStandard"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticStyle: { "text-align": "right", margin: "10px 0" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.batchReviewDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.confirm },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.determine")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("home.reviewResult"),
            visible: _vm.auditResultDialog,
            width: "580px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.auditResultDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "flx-between",
              staticStyle: { "font-size": "16px" },
            },
            [
              _c("div", [
                _vm._v(" " + _vm._s(_vm.$t("home.operationTotal")) + ":"),
                _c("span", { staticClass: "tipclass" }, [
                  _vm._v(_vm._s(_vm.resultsObj.operateTotal)),
                ]),
              ]),
              _c("div", [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("operationCenter.NumberOfSuccesses")) +
                    ":"
                ),
                _c("span", { staticClass: "tipclass" }, [
                  _vm._v(_vm._s(_vm.resultsObj.operateSuccesses)),
                ]),
              ]),
              _c("div", [
                _vm._v(
                  " " + _vm._s(_vm.$t("operationCenter.NumberOfFailures")) + ":"
                ),
                _c(
                  "span",
                  { staticClass: "tipclass", staticStyle: { color: "red" } },
                  [_vm._v(_vm._s(_vm.resultsObj.operateFailures))]
                ),
              ]),
            ]
          ),
          _vm.resultsObj.operateFailures
            ? _c(
                "div",
                {
                  staticStyle: {
                    "margin-top": "15px",
                    "font-size": "16px",
                    "line-height": "30px",
                    height: "200px",
                    "overflow-y": "auto",
                  },
                },
                [
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.$t("GlobalSetObj.ReasonForFailure")) + ":"
                    ),
                  ]),
                  _vm._l(
                    _vm.resultsObj.remindersDetailsVOList,
                    function (item, index) {
                      return _c("div", { key: index }, [
                        _c("span", [_vm._v(_vm._s(index + 1) + ".")]),
                        _c("span", [_vm._v(_vm._s(item.reason))]),
                      ])
                    }
                  ),
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.auditResultDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.determine")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }